<template>
  <div class="tips-cintainers">{{ content }}</div>
</template>

<script>
import Bus from "../doc/bus";

export default {
  name: "tips",
  props: ["content", "time"],
  watch: {
    content: {
      handler() {
        if (this.time) {
          setTimeout(() => {
            Bus.$emit("tips", { content: null, time: 0 });
          }, this.time * 1000);
        }
      },
    },
  },
};
</script>

<style  scoped lang="scss">
.tips-cintainers {
  position: absolute;
  top: 0px;
  width: fit-content;
  padding: 10px;
  background-color: rgba(0, 0, 0, 0.5);
  font-size: 14px;
  color: #fff;
  border-radius: 4px;
  left: 0;
  right: 0;
  margin: auto;
}
</style>